import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/h5/entry', component: () => import('@/views/h5/entry'), hidden: true},
  {path: '/h5/visit', component: () => import('@/views/h5/visit'), hidden: true},
  {path: '/h5/salary', component: () => import('@/views/h5/salary'), hidden: true},
  {path: '/pc/entry', component: () => import('@/views/pc/entry'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/employee',
    component: Layout,
    redirect: '/employee/info',
    children: [{
      path: 'search',
      name: 'search',
      component: () => import('@/views/employee/info/search'),
      meta: {title: '员工检索', icon: 'user'}
    }]
  },
  {
    path: '/employee',
    component: Layout,
    redirect: '/employee/info',
    name: 'employee',
    alwaysShow: true,
    meta: {title: '职工管理', icon: 'user'},
    children: [
      {
        path: 'info',
        name: 'info',
        component: () => import('@/views/employee/info/index'),
        meta: {title: '员工信息登记', icon: 'user'}
      },
      {
        path: 'add',
        name: 'addEmployee',
        component: () => import('@/views/employee/info/add'),
        meta: {title: '添加员工信息'},
        hidden: true
      },
      {
        path: 'update',
        name: 'updateEmployee',
        component: () => import('@/views/employee/info/update'),
        meta: {title: '编辑员工信息'},
        hidden: true
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/employee/Notice'),
        meta: {title: '公告', icon: 'user'}
      },
      {
        path: 'entry',
        name: 'entryDetail',
        component: () => import('@/views/employee/entry/entryDetail'),
        meta: {title: '查看入职登记'},
        hidden: true
      },
      {
        path: 'department/info',
        name: 'Department',
        component: () => import('@/views/employee/department/index'),
        meta: {title: '部门管理', icon: 'user'}
      },
      // {
      //   path: 'entry-require',
      //   name: 'EntryRequire',
      //   component: () => import('@/views/employee/EntryRequire'),
      //   meta: {title: '入职须知', icon: 'user'}
      // }
    ]
  },
  {
    path: '/hire',
    component: Layout,
    redirect: '/hire/visit',
    name: 'hire',
    alwaysShow: true,
    meta: {title: '招聘管理', icon: 'hire'},
    children: [
      {
        path: 'visit',
        name: 'visit',
        component: () => import('@/views/hire/visit/index'),
        meta: {title: '求职人员信息', icon: 'hire-info'}
      },
      {
        path: 'unit',
        name: 'unit',
        component: () => import('@/views/hire/unit/index'),
        meta: {title: '用工单位信息', icon: 'hire-info'}
      },
      {
        path: 'unit/add',
        name: 'addUnit',
        component: () => import('@/views/hire/unit/add'),
        meta: {title: '添加用工单位'},
        hidden: true
      },
      {
        path: 'unit/update',
        name: 'updateUnit',
        component: () => import('@/views/hire/unit/update'),
        meta: {title: '编辑用工单位'},
        hidden: true
      }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/salary',
    name: 'finance',
    alwaysShow: true,
    meta: {title: '财务管理', icon: 'finance'},
    children: [
      {
        path: 'salary',
        name: 'salary',
        component: () => import('@/views/finance/salary/index'),
        meta: {title: '员工工资', icon: 'salary'}
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '/business/company',
    name: 'business',
    alwaysShow: true,
    meta: {title: '业务管理', icon: 'business'},
    children: [
      {
        path: 'company/list',
        name: 'company',
        component: () => import('@/views/business/company/index'),
        meta: {title: '合作伙伴', icon: 'company'}
      },
      {
        path: 'company/add',
        name: 'addCompany',
        component: () => import('@/views/business/company/add'),
        meta: {title: '添加合作伙伴信息'},
        hidden: true
      },
      {
        path: 'company/update',
        name: 'updateCompany',
        component: () => import('@/views/business/company/update'),
        meta: {title: '编辑合作伙伴信息'},
        hidden: true
      }
    ]
  },
  {
    path: '/file',
    component: Layout,
    redirect: '/file/company',
    name: 'file',
    alwaysShow: true,
    meta: {title: '文件管理', icon: 'file'},
    children: [
      {
        path: 'employee',
        name: 'employee-file',
        component: () => import('@/views/file/employee'),
        meta: {title: '员工档案', icon: 'user'}
      },
      {
        path: 'company',
        name: 'company-file',
        component: () => import('@/views/file/company'),
        meta: {title: '公司文件', icon: 'company'}
      }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'configs',
        name: 'configs',
        component: () => import('@/views/business/configs/index'),
        meta: {title: '系统配置'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js